import TournamentSplashHeroForm from './TournamentSplashHeroForm';

export default TournamentSplashHeroForm;
